



































import { RadioButton, RadioGroup, FormItem } from 'element-ui'
import { Vue, Prop, Component, Model } from 'vue-property-decorator'

import TermsAndConditions from '@/components/modals/TermsAndConditions.vue'

import Booking from '@/models/booking'

@Component({
  components: {
    [FormItem.name]: FormItem,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    TermsAndConditions,
  },
})
export default class EnrollPaymentTab extends Vue {
  @Prop() termsAndConditionsVisible!: boolean
  @Prop() booking!: Booking
  @Model('payment-method-change') paymentMethod!: string
}
